__turbopack_context__.v({
  "className": "inter_afa68cd5-module__9aScgG__className",
});
